import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientController_CreateBody_Input_Type,
  OnboardingLegalClientDocument,
  useLegalClientCreateBodyMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientBodyParam } from 'api/types/params';

export const useLegalClientCreateBody = () => {
  const [handle, { loading, error: apolloError }] =
    useLegalClientCreateBodyMutation({
      refetchQueries: [OnboardingLegalClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  return {
    loading,
    error,
    createBody: useCallback(
      async (id: string, params: LegalClientBodyParam) => {
        const res = await handle({
          variables: {
            id,
            input: {
              name: params.name,
              type: MutationInput_LegalClientController_CreateBody_Input_Type[
                params.type
              ],
              otherType: params.otherType,
            },
          },
        });
        return !!res?.data?.legalClientCreateBody;
      },
      [handle]
    ),
  };
};
